import { apiGetWithAuth, fetchJsonWithAuth, ensureToken } from './authApi';
import { AUTH_URL, SUBMISSIONS_URL, JOBS_URL, CANDIDATES_URL } from './apiConfig';

export async function getJobSummary(startDate, endDate) {
  const params = new URLSearchParams();
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  const query = params.toString();
  return apiGetWithAuth(JOBS_URL, `/job-summary${query ? `?${query}` : ''}`);
}

export async function getCandidateSummary(startDate, endDate) {
  const params = new URLSearchParams();
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  const query = params.toString();
  return apiGetWithAuth(CANDIDATES_URL, `/profile-summary${query ? `?${query}` : ''}`);
}

export async function getSubmissionSummary(startDate, endDate) {
  const params = new URLSearchParams();
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  const query = params.toString();
  return apiGetWithAuth(SUBMISSIONS_URL, `/profile-summary${query ? `?${query}` : ''}`);
}

export async function getDashboardCards(
  moduleName,
  { method = 'POST', params = {}, body = {} } = {}
) {
  const token = await ensureToken();
  const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };

  const search = new URLSearchParams({ moduleName });
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') search.append(k, String(v));
  });

  const options = { method, headers };
  if (method === 'POST' || method === 'PUT') {
    options.body = JSON.stringify(body ?? {});
  }

  const res = await fetch(`${AUTH_URL}/dashboard/cards?${search.toString()}`, options);
  if (!res.ok) throw new Error(`API ${res.status}: ${res.statusText}`);
  return res.json();
}

export async function getDashboardOnboardingCount(payload, limit = 10, offset = 0) {
  const token = await ensureToken();
  const res = await fetch(
    `${SUBMISSIONS_URL}/dashboard-onboarding-count?offset=${offset}&limit=${limit}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    }
  );
  const json = await res.json();
  return json.data ?? json;
}

export async function getDashboardCalendar(payload = {}) {
  const token = await ensureToken();
  const res = await fetch(`${SUBMISSIONS_URL}/dashboard-calendar`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`API ${res.status}: ${res.statusText}`);
  return res.json();
}
